import { render, staticRenderFns } from "./BbeeAccesosDirectosR.vue?vue&type=template&id=68036e36"
import script from "./BbeeAccesosDirectosR.vue?vue&type=script&lang=js"
export * from "./BbeeAccesosDirectosR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports